import { render, staticRenderFns } from "./base_pdf_viewer.vue?vue&type=template&id=95a2ff9e&scoped=true&"
import script from "./base_pdf_viewer.vue?vue&type=script&lang=js&"
export * from "./base_pdf_viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a2ff9e",
  null
  
)

export default component.exports